export default __webpack_public_path__ + "static/media/lemons.ed31bcaf.png";